// client/src/services/postEventApi.js
//
// The event "After" section (Growth Phase 9, feature_key "post_event").
// Server: server/routes/postEventRoutes.js, mounted at /api/post-event.

import { getJson, postJson, putJson } from './http';

const base = (tenant, eventId) => `/api/post-event/${tenant}/events/${eventId}/after`;

export const getAfter = (tenant, eventId) => getJson(base(tenant, eventId));
export const saveAfterSettings = (tenant, eventId, body) => putJson(base(tenant, eventId), body);
export const listEventPhotos = (tenant, eventId, status) =>
  getJson(`${base(tenant, eventId)}/photos${status ? `?status=${encodeURIComponent(status)}` : ''}`);
export const moderateEventPhoto = (tenant, eventId, photoId, status, caption) =>
  postJson(`${base(tenant, eventId)}/photos/${photoId}`, { status, ...(caption !== undefined ? { caption } : {}) });
export const getSurveyResults = (tenant, eventId) => getJson(`${base(tenant, eventId)}/survey`);
export const getRecap = (tenant, eventId) => getJson(`${base(tenant, eventId)}/recap`);
export const saveRecapDraft = (tenant, eventId, body) => postJson(`${base(tenant, eventId)}/recap`, body);

export const DELAY_CHOICES = [0, 2, 12, 24, 48, 72];

/** True for the "migration not applied" answers (getJson throws "409 …"). */
export function isNotReady(err) {
  return err?.response?.status === 409 || /^409/.test(err?.message || '');
}

/** The server's error text, if it sent one. */
export function errorText(err, fallback) {
  return err?.response?.data?.error || err?.response?.data?.message || fallback;
}
